import { Box, Button, Grid, Stack, Tab, Tabs, Typography } from '@mui/material'
import React from 'react'
import BasicRangeShortcuts from '../../components/date-range-picker/BasicRangeShortcuts'
import { RefreshIcon } from '../../icons'
import DashboardCards from './DashboardCards'
import UsersBarChart from './UsersBarChart'
import TopUserLocations from './TopUserLocations'
import GenderDistributionPieChart from './GenderDistributionPieChart'
import RevenueChart from './RevenueChart'
import ConversionMetrics from './ConversionMetrics'
import AgeDistribution from './AgeDistribution'
import PlatformUsage from './PlatformUsage'
import MobileOSBreakdown from './MobileOSBreakdown'
import PlatformSessions from './PlatformSessions'
import SignupFunnelAnalysis from './SignupFunnelAnalysis'
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { useState } from 'react'
import NewYorkCards from './NewYorkCards'
import CommunicationActivityHub from './new-york/CommunicationActivityHub'
import FinancialMetricsCards from './new-york/FinancialMetricsCards'
import RevenueChartNewYork from './new-york/RevenueChartNewYork'
import ActivityMatrix from './new-york/ActivityMatrix'
import SignUpDistribution from './new-york/SignUpDistribution'
import UserTypeBreakdown from './new-york/UserTypeBreakdown'
import UserFunnel from './new-york/UserFunnel'
import RealtimeTrendCharts from './new-york/RealtimeTrendCharts'
import UserUsagePattern from './new-york/UserUsagePattern'
import UserFlowBreakdown from './new-york/UserFlowBreakdown'
import ConversionFunnelTable from './new-york/ConversionFunnelTable'
import NewYorkSkeleton from './new-york/NewYorkSkeleton'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { setCityFilter, setDateFilter, setResetFilter, setStateFilter } from '../app-container/reducer/filterSlice'
import CommonUserDistribution from './new-york/CommonUserDistribution'
import CountrySelect from '../../components/country-select/CountrySelect'
import FilterState from '../../components/country-select/FilterState'

const theme = createTheme({
  typography: {
    fontFamily: 'Indivisible, sans-serif',
  },
});
// Custom Tab Styles
const tabStyles = {
  textTransform: "none",
  fontWeight: 600,
  fontSize: "14px",
  borderRadius: "10px",
  px: 2.5,
  py: 0.7,
  mr: 1,
  minHeight: "32px",
};
const DashboardOverview = () => {
  const [tab, setTab] = useState(0);
  const [nyLoading, setNyLoading] = useState(true);
  const dispatch = useDispatch();
  const { filter } = useSelector((state) => state);
  const selectedCountry = useSelector(state => state.filter.country)
  const defaultDateRange = useSelector((state) => state.filter.defaultDateRange);
  const isNewYork = filter?.state === "New York"
  useEffect(() => {
    if (tab === 1) {
      setNyLoading(true);
      setTimeout(() => setNyLoading(false), 2000); // API ke baad hata dena
      // dispatch the filter action to set the city filter
      dispatch(setStateFilter({
        // city: "New York",
        state: "New York",
        // country: "United States",
      }));
    }
    else {
      dispatch(setStateFilter({ state: null }));
    }
  }, [tab]);

  const handleReset = () => {
    dispatch(setResetFilter());
    dispatch(setDateFilter({ dateRange: defaultDateRange }));
    // showSuccessNotification('Filters are now set to their default values.');
  };
  return (
    <>
      <ThemeProvider theme={theme}>
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', }}>
          <Typography sx={{ fontSize: '16px', fontWeight: '600', color: '#000' }}>Dashboard Overview</Typography>

          <Box sx={{ display: 'flex', justifyContent: 'end', alignItems: 'center', gap: 1.5, }}>
            <Box sx={{ mt: 2 }}>
              <Tabs
                value={tab}
                TabIndicatorProps={{ sx: { display: 'none' } }}
                onChange={(e, v) => setTab(v)}
                sx={{
                  "& .MuiTabs-flexContainer": { display: "flex", alignItems: "center" },
                }}
              >
                <Tab
                  label="All"
                  sx={{
                    ...tabStyles,
                    bgcolor: tab === 0 ? "rgb(255, 74, 74,0.05)" : "#F3F4F6",
                    color: tab === 0 ? "#2B1E1A" : "#4B5563",
                    "&.Mui-selected": {
                      color: "#BE1F1F",
                    },
                  }}
                />

                <Tab
                  label="New York"
                  sx={{
                    ...tabStyles,
                    bgcolor: tab === 1 ? "rgb(255, 74, 74,0.05)" : "#F3F4F6",
                    color: tab === 1 ? "#2B1E1A" : "#4B5563",
                    "&.Mui-selected": {
                      color: "#BE1F1F",
                    },
                  }}
                />
              </Tabs>
            </Box>
            <BasicRangeShortcuts id="range1" />
            {/* <Typography sx={{ fontSize: '14px', color: '#7A7A7A', }}>Last updated: 7/29/2025, 6:09:12 PM</Typography> */}
            {/* <Button sx={{ p: 0, minWidth: 'auto', }}><RefreshIcon /></Button> */}
          </Box>
        </Box>
        {/* Tabs */}

        {/* TAB CONTENT AREA */}
        {tab === 0 && !filter?.statsType && !isNewYork && (
          <>
            <div className='d-flex gap-2 justify-content-end align-items-center'>
              <div className="bg-light-100 w-auto d-flex align-items-center gap-3 radius-8" style={{ border: '1px solid #d1d5db', }}>
                <CountrySelect />
                {selectedCountry ?
                  <FilterState /> : null}
              </div>
              <Button
                className=""
                onClick={() => handleReset()}
                sx={{
                  textTransform: 'capitalize',
                  fontSize: '14px',
                  fontWeight: '500',
                  color: '#000',
                  height: '40px',
                  borderRadius: '8px',
                  border: '1px solid #d1d5db', // light gray border
                  backgroundColor: '#fff',
                  transition: 'all 0.3s ease',
                  '&:hover': {
                    backgroundColor: '#BE1F1F', // blue hover
                    color: '#fff', // white text on hover
                    borderColor: '#ff4A4A', // blue border
                  },
                }}
              >
                Reset
              </Button>
            </div>
            <DashboardCards />
            <Grid container spacing={2}>
              <Grid item xs={6} sm={6}>
                <Box>
                  <UsersBarChart />
                  <GenderDistributionPieChart />
                </Box>
              </Grid>
              <Grid item xs={6} sm={6}>
                <TopUserLocations />
              </Grid>
            </Grid>
            <Stack spacing={2} py={2}>
              <RevenueChart />
              <ConversionMetrics />
              <AgeDistribution />
            </Stack>
            {/* <PlatformUsage /> */}
            <Stack spacing={2} py={2}>
              <SignupFunnelAnalysis />
              {/* from new york */}
               <CommunicationActivityHub />
              <ActivityMatrix />
              <CommonUserDistribution />
              <UserFunnel />
              <RealtimeTrendCharts />
              <UserUsagePattern />
              <UserFlowBreakdown />
              <ConversionFunnelTable />
            </Stack>

          </>
        )}

        {tab === 1 && !filter?.statsType && isNewYork && (
          <Box sx={{ mt: 2 }}>
            {nyLoading ? (
              <NewYorkSkeleton />
            ) : (
              <>
                <NewYorkCards />
                <Stack spacing={2} py={2}>
                  <AgeDistribution />
                  <CommunicationActivityHub />
                  <FinancialMetricsCards />
                  <RevenueChartNewYork />
                  <ActivityMatrix />
                  <CommonUserDistribution />
                  {/* <SignUpDistribution />
                  <UserTypeBreakdown /> */}
                  {/* <UserFunnel /> */}
                  <RealtimeTrendCharts />
                  <UserUsagePattern />
                  <UserFlowBreakdown />
                  <ConversionFunnelTable />
                </Stack>
              </>
            )}
          </Box>
        )}

      </ThemeProvider>
    </>
  )
}

export default DashboardOverview
